// extracted by mini-css-extract-plugin
var _1 = "ScrollContainers-modulecontainer__rdEFe ScrollContainer-moduleScrollContainer__LHyVB";
var _2 = "ScrollContainers-modulecontent__Zn7T4";
export { _1 as "container", _2 as "content" }
